export default __webpack_public_path__ + "static/media/localname.895435d5.svg";